import * as React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useFetchCustomTimeRangeCategories } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'
import { useFetchCustomTimeRanges } from 'modules/attendance/hooks/useFetchCustomTimeRanges'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useFetchTimeSettingsCustomTimeRangeCategories } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import Content from './Content'

interface Props {
  settingId: number
}

const CustomTimeRanges = ({ settingId }: Props) => {
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const { categories: timeSettingsCategories, loading: loadingTimeSettingCategories } =
    useFetchTimeSettingsCustomTimeRangeCategories(currentCompanyId)
  const { categories: timeRangeCategories, loading: loadingCustomTimeRangeCategories } =
    useFetchCustomTimeRangeCategories(settingId)
  const { ranges: customTimeRanges, loading: loadingCustomTimeRanges } =
    useFetchCustomTimeRanges(settingId)

  const loading =
    loadingTimeSettingCategories || loadingCustomTimeRangeCategories || loadingCustomTimeRanges

  return (
    <ResponsivePage.Body showHeader={false} variant="full" loading={loading} error={null}>
      <Content
        timeSettingsCategories={timeSettingsCategories}
        timeRangeCategories={timeRangeCategories}
        customTimeRanges={customTimeRanges}
        settingId={settingId}
      />
    </ResponsivePage.Body>
  )
}

export default CustomTimeRanges
